module.exports = __webpack_public_path__ + "img/avatar4.b66dafb2.png";